module.exports = __webpack_public_path__ + "4a9339497fca04be46534526a16ba940.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/bg-pic.png
// module id = 1502
// module chunks = 0